import {
  grey,
  primary,
  blueGrey,
  secondary,
} from '../../../../utils/brandColors';

export default () => ({
  paperRoot: {
    overflow: 'auto',
    marginTop: '1rem',
    borderRadius: '12px',
  },
  rowLocation: {
    borderBottom: `6px solid ${primary[500]}`,
    borderLeft: `4px solid ${blueGrey[50]}`,
  },
  row: { borderBottom: `2px solid ${blueGrey[500]}` },
  cell: {
    verticalAlign: 'top',
    borderRight: `1px solid ${grey[300]}`,
    maxWidth: 250,
    minWidth: 250,
    padding: 0,
    cursor: 'pointer',
    // '&:hover': { background: blueGrey[100] },
  },
  cellPast: {
    verticalAlign: 'top',
    borderRight: `1px solid ${grey[300]}`,
    maxWidth: 250,
    minWidth: 250,
    padding: 0,
    backgroundColor: grey[50],
    cursor: 'pointer',
    // '&:hover': { background: blueGrey[100] },
  },
  cellNotLocated: {
    verticalAlign: 'top',
    borderRight: `1px solid ${grey[300]}`,
    maxWidth: 250,
    minWidth: 250,
    padding: 0,
    backgroundColor: secondary[700],
    cursor: 'pointer',
    '&:hover': { background: blueGrey[100] },
  },
  cellSticky: {
    borderRight: `1px solid ${grey[300]}`,
    maxWidth: 200,
    minWidth: 200,
    width: 200,
    padding: '6px',
    position: 'sticky',
    left: 0,
    backgroundColor: '#fff',
    zIndex: 100,
  },
  cellHighlight: {
    verticalAlign: 'top',
    borderRight: `1px solid ${grey[300]}`,
    maxWidth: 400,
    minWidth: 400,
    padding: 0,
    cursor: 'pointer',
    // '&:hover': { background: blueGrey[100] },
  },
  cellHeadHighlight: {
    borderRight: `1px solid ${grey[300]}`,
    fontSize: 16,
    fontWeight: 600,
    textAlign: 'center',
    backgroundColor: blueGrey[500],
    color: blueGrey[50],
    cursor: 'pointer',
  },
  cellHead: {
    borderRight: `1px solid ${grey[300]}`,
    fontSize: 16,
    fontWeight: 600,
    textAlign: 'center',
    backgroundColor: blueGrey[50],
    color: primary.main,
    cursor: 'pointer',
  },
  cellHeadSticky: {
    fontSize: 16,
    fontWeight: 600,
    textAlign: 'center',
    backgroundColor: 'white !important',
    color: blueGrey[50],
    position: 'sticky',
    left: 0,
    zIndex: '101 !important',
  },
});
